export enum BlockContentContext {
  Article = 'article',
  Stripped = 'stripped',
}
